import React, { createContext, ReactNode, useMemo } from 'react';
import zhCN from './zh_CN';
import { Locale as TypeLocale } from './iLocale';
import { getLangInfo } from './tool';

// 创建 context
export const BeeLocaleContext = createContext<{ beeLocale: TypeLocale & { exist: boolean } }>({
    beeLocale: { ...zhCN, exist: true }
});

type LocaleProps = {
    locale?: TypeLocale;
    children: ReactNode;
};

const Locale: React.FC<LocaleProps> & { getLangInfo: typeof getLangInfo } = ({
    locale = zhCN,
    children
}) => {
    // 保证 beeLocale 结构和 exist 字段
    const value = useMemo(
        () => ({
            beeLocale: {
                ...locale,
                exist: true
            }
        }),
        [locale]
    );

    return (
        <BeeLocaleContext.Provider value={value}>
            {React.Children.only(children)}
        </BeeLocaleContext.Provider>
    );
};

Locale.getLangInfo = getLangInfo;

export default Locale;